import Footer from '@/components/Footer'
import StakePage from '../Stake'
import Share from '@/pages/Share'
import Team from '@/pages/Team'
import WithDraw from '@/pages/Withdraw'
import { Button, ButtonGroup } from '@nextui-org/react'
import { useEffect, useState } from 'react'
import { cnTw } from '@/utils'
import BOTTOM from '@/assets/help/help-bottom-bg.png'

import STAKE_BG from '@/assets/stake/stake-top-bg.png'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

const typeArr = [
	{ key: 'stake', value: 'app.stake.tabs.title1' },
	{ key: 'withdraw', value: 'app.stake.tabs.title2' },
	{ key: 'team', value: 'app.stake.tabs.title3' },
]

export const stakeStyles = {
	base: 'border border-[#3a3a3a] rounded-2xl flex flex-col gap-5 w-full p-4 bg-[#131316]',
}

export default function NewStake() {
	const { t } = useTranslation()
	const [type, setType] = useState<string>('stake')

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	const [params] = useSearchParams()
	const inviteParams = params.getAll('invite')[0]

	useEffect(() => {
		if (typeof inviteParams === 'string') {
			setType('team')
		}
	}, [inviteParams])

	return (
		<div className="relative flex-1 sm:overflow-hidden sm:overflow-y-scroll">
			<img src={STAKE_BG} alt="" className="absolute -top-[4.5rem] right-0 sm:top-0 sm:rounded-t-2xl" />
			<div className="relative z-10 flex items-center justify-center gap-4 pb-10 pt-5 sm:mt-20">
				<ButtonGroup className="rounded-full border border-white/[0.17] bg-white/[0.07]">
					{typeArr.map((item, index) => (
						<Button
							onClick={() => setType(item.key)}
							key={index}
							className={cnTw('h-10 !rounded-full px-5', item.key === type && 'border border-[#40A2FF]')}
							radius="sm"
							variant={item.key === type ? 'bordered' : 'light'}
						>
							<span className="text-xs text-white">{t(item.value)}</span>
						</Button>
					))}
				</ButtonGroup>
			</div>
			<div className="relative z-10 px-5">
				{type === 'stake' && <StakePage />}
				{type === 'withdraw' && <WithDraw />}
				{type === 'team' && <Team />}
				<Share />
			</div>
			<Footer />
			<img src={BOTTOM} alt="" className="absolute bottom-0 left-0 z-[1] h-auto w-full" />
		</div>
	)
}
